import { GroupCollection, GroupCollectionIssuer } from '@accredible-frontend-v2/models';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CollectionsListFilters, GroupCollectionPageData } from '../../entities/collections.model';
import { DashboardApiService } from '../db-api.service';

const API_ENDPOINT = '/v1/issuer/organizations';

@Injectable({
  providedIn: 'root',
})
export class CollectionsApiService extends DashboardApiService {
  searchCollections(
    filters: Partial<CollectionsListFilters>,
  ): Observable<GroupCollectionPageData<GroupCollectionIssuer>> {
    return this._post(
      `${API_ENDPOINT}/${this.embedding.departmentId}/group_collections/search`,
      filters,
    ).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }
}
